import React from 'react';
import { EMAIL, WHATSAPP_URL } from '../mock';
import { Mail, MessageCircle } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="gradient-bg-dark text-white py-14">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h4 className="font-heading font-bold text-2xl mb-3">Alguma dúvida?</h4>
        <p className="text-white/80 mb-6">Entre em contato com nosso suporte via WhatsApp! Vamos lhe ajudar com o que for necessário!</p>
        <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-[#25d366] hover:bg-[#20b957] transition-colors px-6 py-3 rounded-lg font-semibold">
          <MessageCircle size={18} /> Mande uma mensagem!
        </a>
        <div className="mt-10 border-t border-white/15 pt-8">
          <p className="uppercase tracking-widest text-xs text-white/60">E-mail para contato</p>
          <a href={`mailto:${EMAIL}`} className="inline-flex items-center gap-2 mt-2 text-white/95 hover:text-white">
            <Mail size={16} /> {EMAIL}
          </a>
        </div>
        <p className="mt-8 text-xs text-white/50">© {new Date().getFullYear()} Academia de Pitágoras — Todos os direitos reservados.</p>
      </div>
    </footer>
  );
}
